import axios from "axios";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { makeUnique } from "../helperJs/helper";
import { ZustandStore } from "../store/zustand-store";
import {
  MAPUSERPROJECT_GET,
  MAPLATEST_DATA,
  MAPOLD_LATEST_DATA,
} from "../services/constants";

const GetLocalTracker = () => {
  const {
    map_keyword_latest_data,
    map_keyword_loc_data,
    map_keyword_old_data,
    CURRLOCATION,
    map_all_loc_data,
    bussiness_name,
    map_project,
    mapdeviceType,
    map_date,
  } = ZustandStore((state) => state);
  const email = localStorage.getItem("admin_mail");

  const showLoaderWithDelay = () => {
    setTimeout(() => {
      ZustandStore.setState({
        mapshowloader: false,
      });
    }, 1000);
  };

  const callLatestDataApi = async (latestData) => {

    try {
      const response = await axios.get(MAPLATEST_DATA(latestData));
      return { location: latestData.location_name, data: response.data };
    } catch (error) {
      console.error(
        `Error fetching data for ${latestData.location_name}:`,
        error
      );
      return { location: latestData.location_name, error: true };
    }
  };

  const callOldDataApi = async (latestData) => {
    try {
      const response = await axios.get(MAPOLD_LATEST_DATA(latestData));
      return { location: latestData.location_name, data: response.data };
    } catch (error) {
      console.error(
        `Error fetching data for ${latestData.location_name}:`,
        error
      );
      return { location: latestData.location_name, error: true };
    }
  };

  const userOldDataUpdate = (data, filterDeviceType, index) => {
    const filterDeviceTypeData = filterDeviceType?.filter((loc) => {
      return loc.location_name === data?.location;
    });

    let oldDataCalculate = {
      INDEX: index,
      LOCATION: data?.location,
      PREVIOUSALLOLDDATA: [],
      ALLOLDKEYWORDDATA: [],
      OLDKEYWORDDATA: [],
    };
    const old_data = data?.data;
    if (old_data?.length !== 0) {
      oldDataCalculate.PREVIOUSALLOLDDATA = old_data?.map((obj) => {
        const keywordSet = new Set();
        const updatedObjData = obj.data.filter((item) => {
          if (!keywordSet.has(item.keyword)) {
            keywordSet.add(item.keyword);
            return true;
          }
          return false;
        });
        return { ...obj, data: updatedObjData };
      });

      oldDataCalculate?.PREVIOUSALLOLDDATA?.map((upRes, key) => {
        const UserAllKeywordResult = [];
        const UserAllPendingResult = [];
        const KeywordData = [];

        filterDeviceTypeData?.forEach((detail) => {
          detail.keyword &&
            detail.keyword.forEach((onlyKeyword) => {
              const foundKeyword = upRes.data.find(
                (rankKeyword) => rankKeyword.keyword === onlyKeyword
              );
              if (foundKeyword) {
                UserAllKeywordResult.push(foundKeyword);
                KeywordData.push(foundKeyword.data[0]);
              } else {
                UserAllPendingResult.push(onlyKeyword);
              }
            });
        });

        oldDataCalculate.ALLOLDKEYWORDDATA.push({
          data: KeywordData,
          date: upRes.date,
          month: upRes.month,
          year: upRes.year,
        });
      });

      oldDataCalculate.OLDKEYWORDDATA =
        oldDataCalculate.ALLOLDKEYWORDDATA[
          oldDataCalculate.ALLOLDKEYWORDDATA?.length - 1
        ]?.data;

      return oldDataCalculate;
    } else {
      return oldDataCalculate;
    }
  };

  const userLatestDataUpdate = (data, filterDeviceType, index) => {
    const filterDeviceTypeData = filterDeviceType?.filter((loc) => {
      return loc.location_name === data?.location;
    });
    let latestDataCalculate = {
      INDEX: index,
      LOCATION: data?.location,
      USERCOMPATITORS: [],
      SELECTEDPROJECTNEWDATA: [],
      KEYWORDDATA: [],
      USERALLKEYWORDRESULT: [],
      USERALLPENDINGRESULT: [],
    };

    const latest_data = data?.data;
    latestDataCalculate.USERCOMPATITORS = data?.data[0]?.competitors || [];
    latestDataCalculate.SELECTEDPROJECTNEWDATA = data?.data;
    const selectProjectAllKeyword_Data = data?.data[0]?.data;

    if (latest_data.length !== 0) {
      filterDeviceTypeData &&
        filterDeviceTypeData.forEach((detail) => {
          detail.keyword &&
            detail.keyword.forEach((onlyKeyword) => {
              const foundKeyword = selectProjectAllKeyword_Data?.find(
                (rankKeyword) => rankKeyword.keyword === onlyKeyword
              );
              if (foundKeyword) {
                foundKeyword["location"] = detail?.location_name;
                latestDataCalculate.USERALLKEYWORDRESULT.push(foundKeyword);
                latestDataCalculate.KEYWORDDATA.push(foundKeyword.data[0]);
              } else {
                latestDataCalculate.USERALLPENDINGRESULT.push(onlyKeyword);
              }
            });
        });
    } else {
      latestDataCalculate.USERALLPENDINGRESULT =
        filterDeviceTypeData[0]?.keyword || [];
    }
    return latestDataCalculate;
  };

  const userDataUpdate = async (userAllProjectDetails) => {
    ZustandStore.setState({
      mapshowloader: true,
    });
    const userAllProject = userAllProjectDetails?.flatMap((res) => res.Project);
    const selectedProject = userAllProjectDetails.find(
      (res) => res.Project[0].bussiness_name === bussiness_name
    );
    const userselectedprojectallid = Number(selectedProject?.id);
    if (selectedProject) {
      ZustandStore.setState({
        selected_project_id: userselectedprojectallid,
      });
    }

    if (userAllProject.length !== 0) {
      // ----------first project name of user---------- //
      const firstProject = userAllProject[0]?.bussiness_name;
      if (mapdeviceType === null) {
        const deviceType = userAllProject[0]?.deviceType;
        ZustandStore.setState({
          mapdeviceType: deviceType,
        });
      }
      const last_project = sessionStorage.getItem("LAST_MAPPRPJECT_SELECTED");
      if (bussiness_name === null) {
        if (last_project != null) {
          ZustandStore.setState({
            ISPROJECT: true,
            bussiness_name: last_project,
          });
        } else {
          sessionStorage.setItem("LAST_MAPPRPJECT_SELECTED", firstProject);
          ZustandStore.setState({
            ISPROJECT: true,
            bussiness_name: firstProject,
          });
        }
      }
      //----------user selected project all details ----------//
      const filteredUrlBasedData = userAllProject.filter(
        (selectedUrl) => selectedUrl.bussiness_name === bussiness_name
      );

      if (CURRLOCATION.code === null && bussiness_name !== null) {
        ZustandStore.setState({
          USERCURRENTPROJECTLOCATION: filteredUrlBasedData,
          CURRLOCATION: {
            code: "All Locations",
            name: "All Locations",
          },
        });
      } else {
        ZustandStore.setState({
          USERCURRENTPROJECTLOCATION: filteredUrlBasedData,
        });
      }
      // ----------selected project data by LocationCode ---------- //
      const country_Based_Data = filteredUrlBasedData.filter((countrybased) =>
        CURRLOCATION.code === "All Locations"
          ? countrybased
          : countrybased.location_code === CURRLOCATION.code
      );
      // ---------- End getting selected project data by LocationCode ---------- //

      // ---------- Start getting selected project data by  LocationCode with device type ---------- //
      const filterDeviceTypeData = country_Based_Data.filter(
        (type) => type.deviceType === mapdeviceType
      );

      if (CURRLOCATION.code && CURRLOCATION.name && bussiness_name) {
        if (
          CURRLOCATION.name === map_keyword_loc_data &&
          map_keyword_old_data?.length > 0 &&
          map_keyword_latest_data?.length > 0
        ) {
          ZustandStore.setState({
            map_keyword_old_data: map_keyword_old_data,
            map_keyword_latest_data: map_keyword_latest_data,
            map_keyword_loc_data: map_keyword_loc_data,
          });
          showLoaderWithDelay();
        } else if (
          CURRLOCATION.name === "All Locations" &&
          map_all_loc_data?.length === 0
        ) {
          ZustandStore.setState({
            map_keyword_loc_data: "All Locations",
          });

          const getCountry = filterDeviceTypeData
            ?.map((item) => {
              if (item.keyword?.length === 0) return null;
              return {
                location_name: item.location_name,
                location_code: item.location_code,
              };
            })
            .filter(Boolean);

          let uniqueCountry = makeUnique(getCountry);

          const allPromises = uniqueCountry.map((location) => {
            const latestData = {
              id: userselectedprojectallid, // project data id
              email: email,
              deviceType: mapdeviceType, // default is desktop
              location_code: location?.location_code, // country code
              weburl: "", // selected domain
              bussiness_name: encodeURIComponent(bussiness_name),
              location_name: location?.location_name, // country name
            };

            const oldData = {
              ...latestData,
              days: map_date?.day,
            };

            return Promise.allSettled([
              callLatestDataApi(latestData),
              callOldDataApi(oldData),
            ]);
          });
          const results = await Promise.all(allPromises);

          const successfulLatestData = results
            ?.map((result) => result[0])
            .filter((result) => result.status === "fulfilled")
            .map((result) => result.value);

          const successfulOldData = results
            ?.map((result) => result[1])
            .filter((result) => result.status === "fulfilled")
            .map((result) => result.value);

          if (successfulLatestData) {
            const data = successfulLatestData?.map((loc, index) => {
              return userLatestDataUpdate(
                successfulLatestData?.[index],
                filterDeviceTypeData,
                index
              );
            });

            ZustandStore.setState({
              map_keyword_latest_data: data,
            });
          }

          if (successfulOldData) {
            const data = successfulOldData?.map((loc, index) => {
              return userOldDataUpdate(
                successfulOldData?.[index],
                filterDeviceTypeData,
                index
              );
            });

            ZustandStore.setState({
              map_keyword_old_data: data,
            });
          }
          showLoaderWithDelay();
        } else if (map_all_loc_data?.length > 0) {
          const data = map_all_loc_data?.[0];
          if (CURRLOCATION.name === "All Locations") {
            ZustandStore.setState({
              map_keyword_old_data: data?.map_keyword_old_data,
              map_keyword_latest_data: data?.map_keyword_latest_data,
              map_keyword_loc_data: CURRLOCATION.name,
            });
          } else {
            const old_data = data?.map_keyword_old_data?.filter((item) => {
              return item.LOCATION === CURRLOCATION.name;
            });
            const new_data = data?.map_keyword_latest_data?.filter((item) => {
              return item.LOCATION === CURRLOCATION.name;
            });
            ZustandStore.setState({
              map_keyword_old_data: old_data,
              map_keyword_latest_data: new_data,
              map_keyword_loc_data: CURRLOCATION.name,
            });
          }
          showLoaderWithDelay();
        } else {
          ZustandStore.setState({
            map_keyword_loc_data: CURRLOCATION.name,
            map_keyword_old_data: [],
            map_keyword_latest_data: [],
          });
          const latestData = {
            id: userselectedprojectallid, // project data id
            email: email,
            deviceType: mapdeviceType, // default is desktop
            location_code: CURRLOCATION.code, // country code
            weburl: "", // selected domain
            bussiness_name: encodeURIComponent(bussiness_name),
            location_name: CURRLOCATION.name,
            days: map_date?.day, // country name
          };
          const [getLatestData, getOldData] = await Promise.all([
            callLatestDataApi(latestData),
            callOldDataApi(latestData),
          ]);
          if (getOldData?.data) {
            const data = userOldDataUpdate(getOldData, filterDeviceTypeData, 0);
            ZustandStore.setState({
              map_keyword_old_data: [data],
            });
          }
          if (getLatestData?.data) {
            const data = userLatestDataUpdate(
              getLatestData,
              filterDeviceTypeData,
              0
            );
            ZustandStore.setState({
              map_keyword_latest_data: [data],
            });
          }
          showLoaderWithDelay();
        }
      }
    } else {
      sessionStorage.removeItem("LAST_MAPPRPJECT_SELECTED");
      ZustandStore.setState({
        map_project: [],
        ISPROJECT: false,
        mapshowloader: false,
      });
    }
  };

  const getUserProject = () => {
    if (email == null) return;
    axios
      .get(MAPUSERPROJECT_GET(email))
      .then((response) => {
        if (response.data.data?.length > 0) {
          ZustandStore.setState(() => ({
            map_project: response.data.data,
          }));
          userDataUpdate(response.data?.data);
        } else {
          sessionStorage.removeItem("LAST_MAPPRPJECT_SELECTED");
          ZustandStore.setState({
            ISPROJECT: false,
            mapshowloader: false,
          });
        }
      })
      .catch((error) => console.log("error while getting data", error));
  };

  useEffect(() => {
    if (map_project?.length > 0) {
      userDataUpdate(map_project); // need to update on refresh, add proj and delete proj
    } else {
      getUserProject();
    }
  }, [map_project, email, CURRLOCATION, mapdeviceType, map_date]);

  return null;
};

export default GetLocalTracker;
